import Vue from "vue";

const state = {
  surgery: {},
  addresses: [],
  address: {
    label: "",
    address: "",
    apt_no: "",
    state: "",
    postcode: "",
    city: "",
    countryId: ""
  }
};
const getters = {};

const actions = {
  CREATE_ADDRESS: async function({ dispatch, commit, rootState }, payload) {
    let label = `${payload.aptNo} ${payload.address}, ${payload.city}, ${payload.postcode}`;
    label = label.length > 25 ? `${label.substring(0, 25)}...` : label;
    await Vue.prototype.$axios
      .post("/surgeries/" + rootState.auth.user.usurgery + "/addresses", {
        ...payload,
        label: label
      })
      .then(() => {
        commit("SET_EMPTY_ADDRESS");
      });
    await dispatch("GET_SURGERY_ADDRESS");
  },
  UPDATE_ADDRESS: async function({ dispatch, commit, rootState }, payload) {
    await Vue.prototype.$axios
      .post(
        "/surgeries/" +
          rootState.auth.user.usurgery +
          "/addresses/" +
          payload.id,
        payload
      )
      .then(() => {
        commit("SET_EMPTY_ADDRESS");
      });
    await dispatch("GET_SURGERY_ADDRESS");
  },
  DELETE_ADDRESS: async function({ dispatch, rootState }, payload) {
    await Vue.prototype.$axios.delete(
      "/surgeries/" + rootState.auth.user.usurgery + "/addresses/" + payload.id
    );
    await dispatch("GET_SURGERY_ADDRESS");
  },
  LOAD_SURGERY: function({ commit, rootState }, payload) {
    if (payload == undefined || payload == null) {
      Vue.prototype.$axios
        .get("/surgeries/" + rootState.auth.user.usurgery)
        .then(response => {
          commit("LOAD_SURGERY", response.data.surgery);
        });
    } else {
      Vue.prototype.$axios.get("surgeries/" + payload).then(response => {
        commit("LOAD_SURGERY", response.data.surgery);
      });
    }
  },
  SAVE_SURGERY: async function(context, payload) {
    await Vue.prototype.$axios.post("/surgeries/" + payload.id, payload).then(
      () => {},
      err => {
        throw new Error(err.response.data.meta.message);
      }
    );
  },
  GET_SURGERY_ADDRESS: async function({ commit, rootState }) {
    await Vue.prototype.$axios
      .get("/surgeries/" + rootState.auth.user.usurgery + "/addresses")
      .then(response => {
        commit("LOAD_SURGERY_ADDRESSES", response.data.surgeryAddresses);
      });
  },
  INVITE_USER_TO_SURGER: async function({ rootState }, payload) {
    await Vue.prototype.$axios.post(
      "/invites/" + rootState.auth.user.usurgery,
      payload
    );
  }
};

const mutations = {
  LOAD_SURGERY: function(state, payload) {
    state.surgery = payload;
  },
  LOAD_SURGERY_ADDRESSES: function(state, payload) {
    state.addresses = payload;
  },
  LOAD_ADDRESS(state, payload) {
    state.address = payload;
  },
  SET_EMPTY_ADDRESS(state) {
    state.address = {
      label: "",
      address: "",
      apt_no: "",
      state: "",
      postcode: "",
      city: "",
      countryId: ""
    };
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
